import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';


@Component({
  selector: 'submit-pre-stage-pm',
  templateUrl: './submit-pre-stage-pm.component.html',
  standalone: false
})
export class SubmitPreStagePMComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
    
}
